<template>
  <div>
    <TitleName :TitleName="TitleName"></TitleName>
    <div class="contact">
      <div class="contact_box">
        <div class="contact_box_type"><i class="iconfont icon-yonghuming1"></i>邮箱：</div>
        <div class="contact_box_value">{{ Contact.email }}</div>
      </div>
      <div class="contact_box">
        <div class="contact_box_type"><i class="iconfont icon-yonghuming1"></i>电话：</div>
        <div class="contact_box_value">{{ Contact.telphone }}</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ["Contact"],
  components: {
    TitleName: () => import("@/components/DataDetails/Other/TitleName.vue"),
  },
  data() {
    return {
      TitleName: "联系信息",
    };
  },
};
</script>

<style lang="scss" scoped>
.contact_box{
    display: flex;
    height: 30px;
    font-size: 14px;
    .contact_box_type{
        width: 70px;
    }   
    .contact_box_value{

    }
}
</style>